import { __assign, __rest } from "tslib";
import * as React from "react";
import { PnmacPageBubble, PnmacMediaQuery, PnmacMeta, PnmacLinearProgress } from 'pnmac-universal-components';
import { connect } from "react-redux";
import * as Actions from "../../redux/actions/actions.js";
import { bindActionCreators } from "redux";
import styles from '../../styles/styles.js';
import { currencyFormatterWithoutSign, amountNullCheck } from '../../utils.js';
import { View, Image, StyleSheet, TouchableOpacity, Text } from 'react-native';
import moment from 'moment';
import EscrowAnalysisPaymentBreakdown from "../EscrowAnalysisPaymentChange/EscrowAnalysisPaymentBreakdown.js";
import EscrowAnalysisDetails from "./EscrowAnalysisDetails.js";
import EscrowAnalysisDescriptionBanner from "../EscrowAnalysisPaymentChange/EscrowAnalysisDescriptionBanner.js";
import EscrowAnalysisFooterBanner from "../EscrowAnalysisPaymentChange/EscrowAnalysisFooterBanner.js";
import BannerView from '../../v2/BannerView';
import { textStyle } from '../../v2/theme';
var AnalysisChangeSummary = function (_a) {
  var matches = _a.matches,
    translations = _a.translations,
    props = __rest(_a, ["matches", "translations"]);
  var _b = React.useState(false),
    shouldShowPrincipalInfo = _b[0],
    setShouldShowPrincipalInfo = _b[1];
  var lookBackDataLatest = props.layout.escrowAnalysisLookBackData.length > 0 ? props.layout.escrowAnalysisLookBackData[0] : [];
  var lookBackDataPrevious = props.layout.escrowAnalysisLookBackData.length > 1 ? props.layout.escrowAnalysisLookBackData[1] : [];
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(View, {
    style: [eapStyles.summaryContainer, __assign(__assign({}, styles.shadowStyles), {
      borderRadius: 10,
      overflow: 'hidden'
    })]
  }, /*#__PURE__*/React.createElement(View, {
    style: eapStyles.summaryView
  }, /*#__PURE__*/React.createElement(Text, {
    style: [textStyle.formBody, {
      flex: 2.2
    }, {
      fontSize: matches.small ? 14 : 16,
      fontWeight: "bold",
      color: "#000"
    }]
  }, translations.EAPPaymentDetails), /*#__PURE__*/React.createElement(Text, {
    style: [textStyle.formBody, {
      flex: 1
    }, {
      fontSize: matches.small ? 14 : 16,
      fontWeight: "bold",
      color: "#000"
    }]
  }, translations.EAPPrevious), /*#__PURE__*/React.createElement(Text, {
    style: [textStyle.formBody, {
      flex: 1.4
    }, {
      fontSize: matches.small ? 14 : 16,
      fontWeight: "bold",
      color: "#000"
    }]
  }, translations.EAPNew)), /*#__PURE__*/React.createElement(View, {
    style: eapStyles.summaryView
  }, /*#__PURE__*/React.createElement(View, {
    style: {
      flexDirection: "row",
      alignSelf: 'center',
      alignItems: 'center',
      flex: 2.2
    }
  }, /*#__PURE__*/React.createElement(Text, {
    style: [textStyle.formBody, eapStyles.summaryRightAlign, {
      fontSize: matches.small ? 14 : 16
    }]
  }, translations.EAPPrincipalAndInterest)), /*#__PURE__*/React.createElement(Text, {
    style: [textStyle.formBody, {
      flex: 1
    }, {
      fontSize: matches.small ? 14 : 16
    }]
  }, amountNullCheck(lookBackDataPrevious === null || lookBackDataPrevious === void 0 ? void 0 : lookBackDataPrevious.principalAndInterestAmount)), /*#__PURE__*/React.createElement(Text, {
    style: [textStyle.formBody, {
      flex: 1.4
    }, {
      fontSize: matches.small ? 14 : 16
    }]
  }, (lookBackDataLatest === null || lookBackDataLatest === void 0 ? void 0 : lookBackDataLatest.principalAndInterestAmount) ? currencyFormatterWithoutSign('en-US', 'currency', 'USD', lookBackDataLatest === null || lookBackDataLatest === void 0 ? void 0 : lookBackDataLatest.principalAndInterestAmount) : "N/A")), /*#__PURE__*/React.createElement(View, {
    style: eapStyles.summaryView
  }, /*#__PURE__*/React.createElement(Text, {
    style: [textStyle.formBody, {
      flex: 2.2
    }, {
      fontSize: matches.small ? 14 : 16
    }]
  }, translations.EAPEscrowPayment), /*#__PURE__*/React.createElement(Text, {
    style: [textStyle.formBody, {
      flex: 1
    }, {
      fontSize: matches.small ? 14 : 16
    }]
  }, amountNullCheck(lookBackDataPrevious === null || lookBackDataPrevious === void 0 ? void 0 : lookBackDataPrevious.monthlyEscrowPaymentAmount)), /*#__PURE__*/React.createElement(Text, {
    style: [textStyle.formBody, {
      flex: 1.4
    }, {
      fontSize: matches.small ? 14 : 16
    }]
  }, (lookBackDataLatest === null || lookBackDataLatest === void 0 ? void 0 : lookBackDataLatest.monthlyEscrowPaymentAmount) ? currencyFormatterWithoutSign('en-US', 'currency', 'USD', lookBackDataLatest === null || lookBackDataLatest === void 0 ? void 0 : lookBackDataLatest.monthlyEscrowPaymentAmount) : "N/A")), /*#__PURE__*/React.createElement(View, {
    style: eapStyles.summaryView
  }, /*#__PURE__*/React.createElement(Text, {
    style: [textStyle.formBody, {
      flex: 2.2
    }, {
      fontSize: matches.small ? 14 : 16
    }]
  }, translations.EAPShortageAndOrReserveAmount), /*#__PURE__*/React.createElement(Text, {
    style: [textStyle.formBody, {
      flex: 1
    }, {
      fontSize: matches.small ? 14 : 16
    }]
  }, amountNullCheck(lookBackDataPrevious === null || lookBackDataPrevious === void 0 ? void 0 : lookBackDataPrevious.monthlyShortageAndOrReserveAmount)), /*#__PURE__*/React.createElement(Text, {
    style: [textStyle.formBody, {
      flex: 1.4
    }, {
      fontSize: matches.small ? 14 : 16
    }]
  }, (lookBackDataLatest === null || lookBackDataLatest === void 0 ? void 0 : lookBackDataLatest.monthlyShortageAndOrReserveAmount) ? currencyFormatterWithoutSign('en-US', 'currency', 'USD', lookBackDataLatest === null || lookBackDataLatest === void 0 ? void 0 : lookBackDataLatest.monthlyShortageAndOrReserveAmount) : "N/A")), /*#__PURE__*/React.createElement(View, {
    style: eapStyles.summaryView
  }, /*#__PURE__*/React.createElement(Text, {
    style: [textStyle.formBody, {
      flex: 2.2
    }, {
      fontSize: matches.small ? 14 : 16
    }]
  }, translations.EAPMonthlyPayment), /*#__PURE__*/React.createElement(Text, {
    style: [textStyle.formBody, {
      flex: 1
    }, {
      fontSize: matches.small ? 14 : 16
    }]
  }, amountNullCheck(lookBackDataPrevious === null || lookBackDataPrevious === void 0 ? void 0 : lookBackDataPrevious.newMonthlyEscrowPaymentAmount)), /*#__PURE__*/React.createElement(Text, {
    style: [textStyle.formBody, {
      flex: 1.4
    }, {
      fontSize: matches.small ? 14 : 16
    }]
  }, (lookBackDataLatest === null || lookBackDataLatest === void 0 ? void 0 : lookBackDataLatest.newMonthlyEscrowPaymentAmount) ? currencyFormatterWithoutSign('en-US', 'currency', 'USD', lookBackDataLatest === null || lookBackDataLatest === void 0 ? void 0 : lookBackDataLatest.newMonthlyEscrowPaymentAmount) : "N/A")), /*#__PURE__*/React.createElement(View, {
    style: eapStyles.summaryView
  }, /*#__PURE__*/React.createElement(Text, {
    style: [textStyle.formBody, {
      flex: 2.2
    }, {
      fontSize: matches.small ? 14 : 16
    }]
  }, translations.EAPPaymentEffective), /*#__PURE__*/React.createElement(Text, {
    style: [textStyle.formBody, {
      flex: 1
    }, {
      fontSize: matches.small ? 13 : 16
    }, {
      fontWeight: matches.small ? '100' : 'normal'
    }]
  }, (lookBackDataPrevious === null || lookBackDataPrevious === void 0 ? void 0 : lookBackDataPrevious.newPaymentEffectiveDate) ? matches.small ? moment(lookBackDataPrevious === null || lookBackDataPrevious === void 0 ? void 0 : lookBackDataPrevious.newPaymentEffectiveDate).format("MMM D,YYYY") : moment(lookBackDataPrevious === null || lookBackDataPrevious === void 0 ? void 0 : lookBackDataPrevious.newPaymentEffectiveDate).format("MMMM D, YYYY") : "N/A"), /*#__PURE__*/React.createElement(Text, {
    style: [textStyle.formBody, {
      flex: 1.4
    }, {
      fontSize: matches.small ? 13 : 16
    }, {
      fontWeight: matches.small ? '100' : 'normal'
    }]
  }, (lookBackDataLatest === null || lookBackDataLatest === void 0 ? void 0 : lookBackDataLatest.newPaymentEffectiveDate) ? matches.small ? moment(lookBackDataLatest === null || lookBackDataLatest === void 0 ? void 0 : lookBackDataLatest.newPaymentEffectiveDate).format("MMM D,YYYY") : moment(lookBackDataLatest === null || lookBackDataLatest === void 0 ? void 0 : lookBackDataLatest.newPaymentEffectiveDate).format("MMMM D, YYYY") : "N/A"))));
};
var EscrowAnalysisPaymentChange = function (props) {
  var translations = props.translations,
    layout = props.layout;
  var selectedLoanNumber = layout.selectedLoanNumber;
  React.useEffect(function () {
    if (layout.reloadingData == false) {
      props.getEscrowAnalysisLookBack(selectedLoanNumber);
    }
  }, [layout.reloadingData, layout.selectedLoanNumber]);
  var analysisData = props.layout.escrowAnalysisLookBackData;
  var lookBackDataLatest = props.layout.escrowAnalysisLookBackData[0];
  return /*#__PURE__*/React.createElement(PnmacMediaQuery, {
    onRefresh: function () {
      props.authenticate(false);
    },
    refreshing: layout.reloadingData,
    queries: {
      small: "(max-width: 599px)",
      medium: "(min-width: 600px) and (max-width: 1199px)",
      large: "(min-width: 1200px)"
    }
  }, function (matches) {
    return /*#__PURE__*/React.createElement(View, {
      style: props.layout.mobile ? {
        padding: 10
      } : {
        paddingLeft: 10
      }
    }, /*#__PURE__*/React.createElement(PnmacMeta, {
      title: translations.EAPChangeTitle
    }), /*#__PURE__*/React.createElement(PnmacPageBubble, {
      accessibilityRole: "header",
      ariaLevel: "1",
      platform: props.layout.mobile ? "mobile" : "web",
      containerStyles: {
        marginBottom: 20,
        marginLeft: 0
      },
      text: translations.EAPChangeTitle
    }), analysisData.length > 0 ? analysisData[0].errorCode === 'EC1' ? /*#__PURE__*/React.createElement(BannerView, null, /*#__PURE__*/React.createElement(BannerView.Text, null, translations.EAPErrorEC1Message)) : /*#__PURE__*/React.createElement(View, null, /*#__PURE__*/React.createElement(BannerView, null, /*#__PURE__*/React.createElement(BannerView.Text, null, translations.EAPChangeHeader, " ", moment(lookBackDataLatest === null || lookBackDataLatest === void 0 ? void 0 : lookBackDataLatest.newPaymentEffectiveDate).format("MMMM D, YYYY"), ".")), /*#__PURE__*/React.createElement(View, {
      style: {
        paddingVertical: 10,
        fontSize: 16,
        flexDirection: 'row',
        alignItems: 'center',
        justifyContent: 'flex-start'
      }
    }, /*#__PURE__*/React.createElement(Text, {
      style: [textStyle.formBody, {
        fontSize: matches.small ? 16 : 18,
        fontWeight: "bold",
        color: "#000"
      }]
    }, translations.EAPLoanNumber, " "), /*#__PURE__*/React.createElement(Text, {
      style: [textStyle.formBody, {
        fontSize: matches.small ? 14 : 16
      }]
    }, " ", selectedLoanNumber)), /*#__PURE__*/React.createElement(EscrowAnalysisPaymentBreakdown, __assign({
      matches: matches,
      translations: translations
    }, props)), /*#__PURE__*/React.createElement(EscrowAnalysisDescriptionBanner, __assign({
      matches: matches,
      translations: translations
    }, props)), /*#__PURE__*/React.createElement(EscrowAnalysisDetails, __assign({
      matches: matches,
      translations: translations
    }, props)), /*#__PURE__*/React.createElement(AnalysisChangeSummary, __assign({
      matches: matches,
      translations: translations
    }, props)), /*#__PURE__*/React.createElement(EscrowAnalysisFooterBanner, __assign({
      matches: matches,
      translations: translations
    }, props))) : props.layout.loadingEscrowUI ? /*#__PURE__*/React.createElement(PnmacLinearProgress, null) : /*#__PURE__*/React.createElement(BannerView, null, /*#__PURE__*/React.createElement(BannerView.Text, {
      idTag1: 'EAPErrorEC1Message'
    }, translations.EAPErrorEC1Message)));
  });
};
var mapStateToProps = function (state) {
  return {
    layout: state,
    translations: state.translations
  };
};
var mapDispatchToProps = function (dispatch) {
  return __assign({
    dispatch: dispatch
  }, bindActionCreators(Actions, dispatch));
};
var eapStyles = StyleSheet.create({
  container: {
    width: "100%",
    backgroundColor: '#fff',
    padding: 10
  },
  summaryContainer: {
    flex: 1,
    alignSelf: 'center',
    alignItems: 'center',
    width: "100%",
    marginTop: 10,
    // borderWidth: 1,
    borderColor: "#DDDDDD",
    // boxShadow: 'rgba(0, 0, 0, 0.24) 0px 3px 4px',
    backgroundColor: "#FFFFFF"
  },
  summaryView: {
    flexDirection: "row",
    alignSelf: 'center',
    alignItems: 'center',
    paddingVertical: 15,
    paddingLeft: 15,
    width: "100%"
  },
  summaryText: {
    flex: 1,
    padding: 5
  },
  summaryRightAlign: {
    textAlign: "right"
  },
  summaryCenterAlign: {
    textAlign: "center"
  },
  normalText: {
    fontSize: 16,
    color: 'black'
  },
  boldText: {
    fontSize: 16,
    color: 'black',
    fontWeight: "bold"
  },
  cardStyle: {
    shadowColor: "rgba(0,0,0, .4)",
    shadowOffset: {
      height: 1,
      width: -1
    },
    shadowOpacity: 1,
    shadowRadius: 5,
    padding: 10,
    marginTop: 10
  }
});
export default connect(mapStateToProps, mapDispatchToProps)(EscrowAnalysisPaymentChange);